export type DeviceType = 'phone' | 'tablet' | 'desktop';
export type PointerType = 'touch' | 'mouse' | 'hybrid';

export class DeviceDetector {
  static getPointerType(): PointerType {
    const hasCoarse = window.matchMedia('(pointer: coarse)').matches;
    const hasFine = window.matchMedia('(pointer: fine)').matches;
    const hasHover = window.matchMedia('(hover: hover)').matches;

    if (hasFine && hasCoarse) return 'hybrid';

    if (hasCoarse && !hasFine) return 'touch';

    if (hasFine && hasHover) return 'mouse';

    return 'mouse';
  }

  static getDeviceType(): DeviceType {
    const width = window.innerWidth;
    const pointerType = this.getPointerType();

    if (pointerType === 'touch' && width < 768) return 'phone';

    if (pointerType === 'touch' && width >= 768) return 'tablet';

    return 'desktop';
  }

  static initialize(): void {
    const update = () => {
      const deviceType = this.getDeviceType();
      const pointerType = this.getPointerType();

      document.documentElement.setAttribute('data-device', deviceType);
      document.documentElement.setAttribute('data-pointer', pointerType);
    };

    update();

    window.addEventListener('resize', update);
  }
}
